//React
import React from "react";

//CSS
import "./styles/colored-text-tag.css";

const TEXT_TAG_COLORS = {
    SUCCESS : "success-text",
    PRIMARY : "primary-text",
    WARN : "warn-text",
    ERROR : "error-text",
}

const ColoredTextTag = (props) => {
  const { text, color } = props;
  return <span className={color}>{text}</span>;
};

export {
    ColoredTextTag,
    TEXT_TAG_COLORS
  };
  